import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BaseAuthState } from '../reducers/base-auth.reducer';

export const getAuth = createFeatureSelector<BaseAuthState>('auth');
export const getUserInfo = createSelector(getAuth, (state) => state.user);
export const getRefreshInfo = createSelector(getAuth, (state: BaseAuthState) => state.refresh);
export const getFirstTimeLoginStatus = createSelector(getAuth, (state: BaseAuthState) => state.isFirstTimeLogin);
export const getCustomizedUserStatus = createSelector(getAuth, (state: BaseAuthState) => state.isCustomizedUser);
export const getRegistrationCheckData = createSelector(getAuth, (state: BaseAuthState) => state.registrationCheck);
